import { BadgeCheck } from "lucide-react";

// Badge de confianza (launch-readiness sprint, sept-2026). Deliberadamente dice
// "Verificación básica" y NO "Empresa verificada" — hoy solo valida formato +
// consistencia interna (NIF/EIN + duplicados + antecedentes), no confirma contra
// el registro oficial (AEAT/IRS). Nunca implica que InfoCityJobs garantiza el empleo.
export function VerificationBadge({ className = "" }) {
  return (
    <span
      data-testid="verification-badge"
      className={`inline-flex items-center gap-1 text-xs font-medium text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full px-2 py-0.5 ${className}`}
      title="Verificación de formato/consistencia interna — no es una confirmación oficial de registro"
    >
      <BadgeCheck className="h-3.5 w-3.5" />
      Verificación básica
    </span>
  );
}
